module.exports = "<p>\n  page-not-found works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/page-not-found/page-not-found.component.html
// module id = ./src/app/pages/page-not-found/page-not-found.component.html
// module chunks = main